import { styled } from 'tamagui'

import { getStaticImageUrl } from '@data/config/imageUrl'

import { Text } from '@newComponents/Text'

export const HeroMainText = styled(Text, {
  fontFamily: '$marker',
  color: '$colorOnPrimary',
  textShadowColor: 'rgba(27, 19, 64, 0.6)',
  textShadowOffset: { width: 0, height: 3 },
  textShadowRadius: 8,
  style: { fontVariantLigatures: 'none' },
})

export const HeroText = styled(Text, {
  fontFamily: '$marker',
  color: '$colorOnPrimary',
  textShadowColor: 'rgba(27, 19, 64, 0.1)',
  textShadowOffset: { width: 0, height: 3 },
  textShadowRadius: 6,
  style: { fontVariantLigatures: 'none' },
})

export const HeroCopyText = styled(Text, {
  fontWeight: '$6',
  color: '$colorOnPrimary',
  textShadowColor: 'rgba(27, 19, 64, 0.1)',
  textShadowOffset: { width: 0, height: 3 },
  textShadowRadius: 6,
})

export const MarkerText = styled(Text, {
  fontFamily: '$marker',
  paddingHorizontal: '$3',
  style: {
    background:
      'linear-gradient(89.31deg, #9A16C8 25.81%, #F880C1 52.29%, #FF8642 76.81%)',
    WebkitTextFillColor: 'transparent',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    lineHeight: '1em',
  },
})

export const MarkerExtrasText = styled(Text, {
  fontFamily: '$markerExtras',
})

export const PURPLE_BOX_SHADOW =
  '0px 100px 80px rgba(85, 51, 235, 0.07), 0px 41.7776px 33.4221px rgba(85, 51, 235, 0.0503198), 0px 22.3363px 17.869px rgba(85, 51, 235, 0.0417275), 0px 12.5216px 10.0172px rgba(85, 51, 235, 0.035), 0px 6.6501px 5.32008px rgba(85, 51, 235, 0.0282725), 0px 2.76726px 2.21381px rgba(85, 51, 235, 0.0196802)'

export const PURPLE_BOX_SHADOW_DARK =
  '0px 100px 80px rgba(167, 139, 250, 0.05), 0px 41.7776px 33.4221px rgba(167, 139, 250, 0.035), 0px 22.3363px 17.869px rgba(167, 139, 250, 0.03), 0px 12.5216px 10.0172px rgba(167, 139, 250, 0.025), 0px 6.6501px 5.32008px rgba(167, 139, 250, 0.02), 0px 2.76726px 2.21381px rgba(167, 139, 250, 0.014)'

export const getPurpleBoxShadow = (isDark: boolean) =>
  isDark ? PURPLE_BOX_SHADOW_DARK : PURPLE_BOX_SHADOW

export const FILLER_GRADIENT_BACKGROUND = getStaticImageUrl(
  'home-page/filler-gradient-background.png'
)
